module.exports = __webpack_public_path__ + "static/img/index-menu-4.45affb94.png";